let logEntries = []

function t () {
  let d = new Date()
  return `[${d.getHours()}:${d.getMinutes()}] `
}

export function log (...args) {
  args.forEach(entry => {
    console.log(entry)
    logEntries.push({ entry: typeof entry === 'string' ? t() + entry : t() + JSON.stringify(entry, null, 2), visible: true })
  })
}

export function getLogEntries () {
  return logEntries
}

export function clearLogs () {
  while (logEntries.length) {
    logEntries.pop()
  }
}
